module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "viewer"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', [_c('router-link', {
    staticClass: "alt-font",
    attrs: {
      "to": _vm.galleryLink
    }
  }, [_vm._v("‹ Pattern Gallery")])], 1), _vm._v(" "), _c('design-view', {
    attrs: {
      "design": _vm.design,
      "readonly": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "download-pdf"
  }, [_c('download-pdf', {
    attrs: {
      "test": "testing"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "save-or-share"
  }, [_c('label', {
    staticClass: "alt-font"
  }, [_vm._v("Save or Share Design")]), _vm._v(" "), _c('save-form')], 1)], 1), _vm._v(" "), (_vm.usedColors.length && _vm.colorsUsedAndPlaceholders.length === 0 && _vm.brand === 'filzfelt') ? _c('div', {
    staticClass: "used-colors"
  }, [_c('h3', {
    staticClass: "h alt-font"
  }, [_vm._v("Colors")]), _vm._v(" "), _vm._l((_vm.usedColors), function(ref) {
    var key = ref[0];
    var count = ref[1];
    var ref_2 = ref[2];
    var name = ref_2.name;
    var value = ref_2.value;
    var idx = ref_2.idx;

    return _c('div', {
      key: key,
      staticClass: "color-item"
    }, [_c('div', {
      staticClass: "color-circle",
      style: (("background: " + value))
    }), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(count > 1 ? (count + " tiles in ") : (count + " tile in ")) + " " + _vm._s(idx) + " " + _vm._s(name))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.colorsUsedAndPlaceholders.length && _vm.brand === 'filzfelt') ? _c('div', {
    staticClass: "used-colors"
  }, [_c('h3', {
    staticClass: "h alt-font"
  }, [_vm._v("Colors")]), _vm._v(" "), _vm._l((_vm.colorsUsedAndPlaceholders), function(ref) {
    var name = ref.name;
    var usedColor = ref.usedColor;
    var placeholderColor = ref.placeholderColor;

    return _c('div', {
      key: name,
      staticClass: "color-item"
    }, [_c('div', {
      staticClass: "color-circle",
      style: (("background: " + (usedColor ? usedColor.value : placeholderColor) + "; " + (usedColor || placeholderColor === 'rgb(255, 255, 255)' ? 'border: 1px solid #000;' : '')))
    }), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(name) + " - " + _vm._s(usedColor ? usedColor.idx : '') + " " + _vm._s(usedColor ? usedColor.name : 'TBD') + "\n        ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isSp402 && _vm.usedBlocks && _vm.brand === 'spinneybeck') ? _c('div', {
    staticClass: "used-colors"
  }, [_c('h3', {
    staticClass: "h alt-font"
  }, [_vm._v("Pattern Breakdown")]), _vm._v(" "), _vm._l((_vm.sp402Breakdown), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "color-item"
    }, [_c('div', {
      staticClass: "value"
    }, [_vm._v("(" + _vm._s(item.count) + ") " + _vm._s(item.tile))])])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isSp402 && _vm.usedBlocks && _vm.brand === 'spinneybeck') ? _c('div', {
    staticClass: "used-colors"
  }, [_c('h3', {
    staticClass: "h alt-font"
  }, [_vm._v("Pattern Breakdown")]), _vm._v(" "), _vm._l((_vm.usedBlocks), function(count, name) {
    return _c('div', {
      key: name,
      staticClass: "color-item"
    }, [_c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(count > 1 ? (count + " tiles in ") : (count + " tile in ")) + " " + _vm._s(name))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "specs"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h alt-font"
  }, [_vm._v("Wall Dimensions")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("W " + _vm._s(_vm.width) + " x H " + _vm._s(_vm.height))])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h alt-font"
  }, [_vm._v("Pattern")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.patternName))])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h alt-font"
  }, [_vm._v("Tile Counts")]), _vm._v(" "), (_vm.coloredTilesCount) ? [(_vm.metric) ? _c('div', {
    staticClass: "value"
  }, [_vm._v("\n            W " + _vm._s(_vm.convertInchesToCm(_vm.coloredTilesDimensions.width)) + " cm x H " + _vm._s(_vm.convertInchesToCm(_vm.coloredTilesDimensions.height)) + " cm\n          ")]) : _c('div', {
    staticClass: "value"
  }, [_vm._v("W " + _vm._s(_vm.inchesToFeetString(_vm.coloredTilesDimensions.width)) + " x H " + _vm._s(_vm.inchesToFeetString(_vm.coloredTilesDimensions.height)))]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.coloredTilesCount) + " tiles")])] : [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.totalTilesCount) + " total tiles")])]], 2), _vm._v(" "), (_vm.tileDimensions) ? [_c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h alt-font"
  }, [_vm._v("Tile Dimensions")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.tileDimensions))])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('router-link', {
    staticClass: "alt-font return-back",
    attrs: {
      "to": "edit"
    }
  }, [_vm._v("Back to Editor")])], 1)], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-328e629d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/pages/View.vue
// module id = 566
// module chunks = 1